import { registerUnauthorizedHandler } from '@/../../common/src/utils/requests/unauthorizedHandler';
import { nativeApi } from '@/../../common/src/utils/nativeApi';
import { t } from 'i18next';
import { h5ApplicationFormSession } from './h5ApplicationFormSessionStore';
import { createVhkUnauthorizedHandler } from './vhkUnauthorizedHandler';

export const registerVhkUnauthorizedHandler = (): (() => void) =>
  registerUnauthorizedHandler(
    createVhkUnauthorizedHandler({
      session: h5ApplicationFormSession,
      runtime: {
        getPlatform: () => nativeApi.name,
        getLinkType: () => nativeApi.h5LinkType,
        getCurrentUrl: () => location.href,
        getOriginalLoginUrl: () => sessionStorage.getItem('h5LinkUrl'),
      },
      navigation: {
        showExpiredDialog: (onConfirm) => {
          setTimeout(() => {
            window.showGlobalDialog?.({
              content: t<string>('credit.expired_info'),
              showCancelButton: false,
              confirmButtonText: t<string>('common_confirm'),
              onConfirm,
            });
          }, 0);
        },
        replaceLocation: (url) => location.replace(url),
      },
    })
  );
